import Image from 'next/image'
import clsx from 'clsx'
import { Tooltip } from 'ui/src/components/Tooltip/Tooltip'
import { tokens } from 'ui/src/theme/tokens.css'
import { getExternalInsurerLogoUrl } from './externalInsurerLogos'
import { fallbackLetter, imageFrame, logoImage, wrapper } from './ExternalInsurerLogo.css'

type Props = {
  insurelyId: string | null | undefined
  displayName: string
  size?: string
  radius?: keyof typeof tokens.radius
  dashed?: boolean
  className?: string
}

export function ExternalInsurerLogo({
  insurelyId,
  displayName,
  size = '3rem',
  radius,
  dashed = false,
  className,
}: Props) {
  const logoUrl = getExternalInsurerLogoUrl(insurelyId)
  const firstLetter = displayName.trim().charAt(0).toUpperCase()

  return (
    <Tooltip.Root>
      <Tooltip.Trigger>
        <div
          className={clsx(wrapper[dashed ? 'dashed' : 'solid'], className)}
          style={{ width: size, height: size, borderRadius: radius ? tokens.radius[radius] : undefined }}
        >
          <div className={imageFrame}>
            {logoUrl ? (
              <Image src={logoUrl} alt={displayName} fill sizes="100%" className={logoImage} />
            ) : (
              <div className={fallbackLetter}>{firstLetter || '?'}</div>
            )}
          </div>
        </div>
      </Tooltip.Trigger>
      <Tooltip.Content>{displayName}</Tooltip.Content>
    </Tooltip.Root>
  )
}
